import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import plusIcon from '../../asset/img/common/addbutton_plus_primary_icon.svg';
import arrowIcon from '../../asset/img/common/arrow_right_icon.svg';
import disabledArrowIcon from '../../asset/img/common/arrow_right_999_icon.svg';
import Typography from './Typography';

const shouldForwardProp = props => !['disabled'].includes(props);

const AddButtonStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  cursor: pointer;
  flex: 1;
`;

const ButtonWrapper2 = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  cursor: pointer;
  flex: 1;
`;

const ImgWrapper = styled.div`
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background: rgba(84, 77, 92, 0.15);
`;

const FullButton = ({ title, status = '', icon, onClick, disabled = false, style, alt }) => {
  const navigate = useNavigate();

  const statusProps = {
    color: status == '1' ? 'success' : 'error',
    label: status == '1' ? '제출' : '미제출',
  };

  return (
    <AddButtonStyled
      style={{ background: 'var(--GrayScale-100)', border: 'none', ...style }}
      onClick={!disabled ? onClick : null}>
      <ButtonWrapper>
        <Typography
          style={{ whiteSpace: 'pre-wrap' }}
          variant="body1Medium"
          color={disabled ? 'GrayScale-600' : 'GrayScale-900'}>
          {title}
        </Typography>
        <img
          src={icon == 'arrow' ? (disabled ? disabledArrowIcon : arrowIcon) : plusIcon}
          alt={icon == 'arrow' ? `${title}` : `${title} 추가`}
        />
      </ButtonWrapper>
    </AddButtonStyled>
  );
};

export default FullButton;

export const FindPasswordButton = ({ title, description, status = '', icon, onClick }) => {
  return (
    <AddButtonStyled
      style={{ background: 'var(--GrayScale-100)', border: 'none' }}
      onClick={onClick}>
      <ButtonWrapper>
        <div className="displayFlexColumn" style={{ gap: '5px' }}>
          <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body2Bold" color="GrayScale-900">
            {title}
          </Typography>
          <Typography
            style={{ whiteSpace: 'pre-wrap' }}
            variant="body2Medium"
            color="GrayScale-700">
            {description}
          </Typography>
        </div>
        <img src={icon == 'arrow' ? arrowIcon : plusIcon} alt="plus" />
      </ButtonWrapper>
    </AddButtonStyled>
  );
};

//추가서류, 분납
export const ResultButton = ({ title, description, status = '', imgSrc, onClick }) => {
  return (
    <AddButtonStyled
      style={{ background: 'var(--GrayScale-100)', border: 'none' }}
      onClick={onClick}>
      <ButtonWrapper2>
        <ImgWrapper>
          <img src={imgSrc} alt={title} />
        </ImgWrapper>
        <div className="displayFlexColumn" style={{ gap: '5px' }}>
          <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body1Bold" color="GrayScale-900">
            {title}
          </Typography>
        </div>
      </ButtonWrapper2>
    </AddButtonStyled>
  );
};
